import React from 'react';
import "./dotSeparator.scss"
export const DotSeparator = () => {
    return <span className="dot-separator">&#8226;</span>

}